import { lazy, Suspense } from "react";
import { Navigate, Route, Routes } from "react-router-dom";

import { ProtectedRoute } from "./authentication/containers/protected-route/protected-route";
import { PATHS } from "./constants";
import { AccessDeniedPage } from "./pages/auth-info/containers/access-denied-page";
import { AccountNotConnectedPage } from "./pages/auth-info/containers/account-not-connected-page";
import { RemoteFailurePage } from "./pages/auth-info/containers/remote-failure-page";
import { SessionExpiredPage } from "./pages/auth-info/containers/session-expired-page";
import { SignedOutPage } from "./pages/auth-info/containers/signed-out-page";
import { NotFoundPage } from "./pages/not-found/not-found-page";

const AssetUsageRecords = lazy(
  () =>
    import(
      "./pages/asset-usage-records/containers/asset-usage-records/asset-usage-records"
    )
);
const AssetStocks = lazy(
  () => import("./pages/asset-stocks/containers/asset-stocks/asset-stocks")
);
const Login = lazy(() => import("./pages/login/containers/ims-login"));
const FarmLands = lazy(() => import("./pages/fields/containers/farm-lands/farm-lands"));
const Catalogs = lazy(() => import("./pages/catalogs/catalogs"));
const Dashboard = lazy(() => import("./pages/dashboard/containers/dashboard/dashboard"));
const MapComponent = lazy(() => import("./pages/map-page/containers/map/map"));
const Observations = lazy(
  () => import("./pages/observations/containers/observations/observations")
);
const TechOperations = lazy(
  () => import("./pages/tech-operations/containers/tech-operations/tech-operations")
);
const FarmLandTechOperationEditingPage = lazy(() =>
  import(
    "./pages/tech-operations/containers/tech-operation-editing/tech-operation-editing-page"
  ).then(({ TechOperationEditingPage }) => ({ default: TechOperationEditingPage }))
);
const TechWorks = lazy(
  () => import("./pages/tech-works/containers/tech-works/tech-works")
);

export const AppRouter = (): JSX.Element => {
  return (
    <Suspense fallback={<div>Loading...</div>}>
      <Routes>
        <Route path={PATHS.LOGIN_PAGE} element={<Login />} />
        {/* Публичные страницы: открываются без сессии и не запускают вход сами. */}
        <Route path={PATHS.ACCESS_DENIED} element={<AccessDeniedPage />} />
        <Route path={PATHS.REMOTE_FAILURE} element={<RemoteFailurePage />} />
        <Route path={PATHS.ACCOUNT_NOT_CONNECTED} element={<AccountNotConnectedPage />} />
        <Route path={PATHS.SESSION_EXPIRED} element={<SessionExpiredPage />} />
        <Route path={PATHS.SIGNED_OUT} element={<SignedOutPage />} />
        <Route path={PATHS.MAIN_PAGE} element={<ProtectedRoute />}>
          <Route path={`${PATHS.CATALOG_PAGE}/*`} element={<Catalogs />} />
          <Route path={`${PATHS.MAP_PAGE}/*`} element={<MapComponent />} />
          <Route path={`${PATHS.TECHOPERATIONS_PAGE}/*`} element={<TechOperations />} />
          <Route path={`${PATHS.TECH_WORKS_PAGE}/*`} element={<TechWorks />} />
          <Route
            path={`${PATHS.FIELDS_PAGE}/:farmLandId${PATHS.TECHOPERATIONS_PAGE}/:id`}
            element={<FarmLandTechOperationEditingPage />}
          />
          <Route path={`${PATHS.FIELDS_PAGE}/*`} element={<FarmLands />} />
          <Route path={`${PATHS.OBSERVATIONS_PAGE}/*`} element={<Observations />} />
          <Route path={`${PATHS.DASHBOARD}/*`} element={<Dashboard />} />
          <Route
            path={`${PATHS.ASSET_USAGE_RECORDS}/*`}
            element={<AssetUsageRecords />}
          />
          <Route path={`${PATHS.ASSET_STOCKS}/*`} element={<AssetStocks />} />
          <Route index={true} element={<Navigate to={PATHS.MAP_PAGE} replace={true} />} />
          <Route path={"*"} element={<NotFoundPage />} />
        </Route>
      </Routes>
    </Suspense>
  );
};
